import request from '../utils/request.js';
let apiConfig = null;
try {
  apiConfig = require('../../src/config/api').default;
} catch (e) {
  // 文件不存在时忽略错误
}
const baseUrl = apiConfig?.VUE_APP_GIAM_Common || process.env.VUE_APP_GIAM_Common;
// 设置定时开启
export function getCampaignSaleReport(data) {
  return request({
    baseURL: baseUrl,
    url: '/rest/campaign/getCampaignSaleReport',
    method: 'post',
    data: data,
    timeout: 0,
    transformRequest: [
      function (data) {
        return data;
      },
    ],
  });
}
